import React from 'react'
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import HomePage from '../Pages/HomePage';
import Acadamics from '../Pages/Acadamics';
import AboutPage from '../Pages/AboutPage';
import Contact from '../Pages/Contact';
import Admission from '../Pages/Admission';
import AdmissionForm from '../Pages/AdmissionForm';
import MarkList from '../Pages/MarkList';
import MarkListEnter from '../Pages/MarkListEnter';

const Router = () => {
  return (
    <div>
      <BrowserRouter>
        <Routes>
          <Route index element={<HomePage />} /> 
          <Route path="/about" element={<AboutPage />} />
          <Route path="/acadamics" element={<Acadamics />} />
          <Route path="/admission" element={<Admission />} />
          <Route path="/admissionform" element={<AdmissionForm />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/mark-list" element={<MarkList />} />
          <Route path="/mark-list-enter" element={<MarkListEnter />} />
        </Routes>
      </BrowserRouter>
    </div>
  )
}


export default Router